import { useTranslation } from "react-i18next";
import { EntityGrid } from "@/components/common/EntityGrid";
import { ListCard } from "./ListCard";
import { List } from "@/types/list";

interface ListsGridProps {
  lists: List[];
  filteredLists: List[];
  isLoading: boolean;
  favorites?: Set<string>;
}

export const ListsGrid = ({ lists, filteredLists, isLoading, favorites = new Set() }: ListsGridProps) => {
  const { t } = useTranslation();

  return (
    <EntityGrid
      data={filteredLists}
      isLoading={isLoading}
      renderItem={(list) => <ListCard list={list} isFavorite={favorites.has(list.id)} />}
      emptyMessage={t("lists.empty.title", "No lists found")}
    />
  );
};
